import * as React from 'react';

const useGetAvailableAgeGroups = (appointmentTypes)=>React.useMemo(()=>{
        const forChildren = appointmentTypes.some(({ ageGroup  })=>ageGroup === 'CHILD'
        );
        const forAdults = appointmentTypes.some(({ ageGroup  })=>ageGroup === 'ADULT'
        );
        const forSeniors = appointmentTypes.some(({ ageGroup  })=>ageGroup === 'SENIOR'
        );
        return {
            forChildren,
            forAdults,
            forSeniors
        };
    }, [
        appointmentTypes
    ])
;
var useGetAvailableAgeGroups$1 = useGetAvailableAgeGroups;

export { useGetAvailableAgeGroups$1 as default };
//# sourceMappingURL=useGetAvailableAgeGroups.js.map
